<template>
  <div>
    <list-header v-if="header" :icon="icon" :title="title" />

    <v-layout row wrap>
      <v-flex
        v-for="(benefit, index) in benefits.list"
        :key="index"
        xs12
        sm6
        xl3
        px-2
        mb-3
        :md1="inrow==12"
        :md2="inrow==6"
        :md3="inrow==4"
        :md4="inrow==3"
        :md6="inrow==2"
      >
        <benefit-item :benefit="benefit" />
      </v-flex>
    </v-layout>

    <v-flex v-if="showMore" md12 text-xs-right mt-2>
      <v-btn light depressed :to="moreTarget">
        <v-icon class="mr-1">event</v-icon>
        <!-- Przycisk Więcej -->
        <slot name="more">
          <!-- Więcej -->
          Więcej
        </slot>
      </v-btn>
    </v-flex>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import ListHeader from '@/components/ListHeader';
import BenefitItem from './BenefitItem';

// @vuese
// Lista usług
// @group Benefits
export default {
  components: { ListHeader, BenefitItem },
  props: {
    // czy pokazywać nagłówek nad listą
    header: { type: Boolean, default: true },
    // ikona do wyświetlenia nad listą
    icon: { type: String, default: 'event' },
    // tytuł listy
    title: { type: String },
    // czy pokazywać slot więcej
    showMore: { type: Boolean, default: false },
    // ikona 'więcej'
    moreIcon: { type: String, default: 'event' },
    // obiekt route do przekazania dla przycisku więcej
    moreTarget: {
      type: Object,
      default: () => {
        return {
          name: 'benefits'
        };
      }
    },
    // ilość w wierszu
    inrow: { type: Number, default: 2 }
  },

  computed: {
    ...mapState({
      benefits: state => state.benefits
    })
  }
};
</script>
